type BrandMarkProps = {
  light?: boolean
  compact?: boolean
}

export function BrandMark({ light = true, compact = false }: BrandMarkProps) {
  return (
    <a className={`brand-mark ${light ? 'brand-mark--light' : ''}`} href="#top" aria-label="Q1 Websites home">
      <svg className="brand-mark__icon" viewBox="0 0 48 58" aria-hidden="true">
        <path d="M4 54V23C4 11 12 4 24 4s20 7 20 19v31H4Z" fill="none" stroke="currentColor" strokeWidth="4" />
        <path d="M17 47V23l15-8v32H17Z" fill="#3856cc" />
        <path d="m37 12 1.7 4.3L43 18l-4.3 1.7L37 24l-1.7-4.3L31 18l4.3-1.7L37 12Z" fill="#c34836" />
      </svg>
      {!compact && <span>Q1 WEBSITES</span>}
    </a>
  )
}
